<script setup>
import { toRefs } from 'vue'
import { PROPS_OPTIONS_TITLE_INDEX } from '../props-options.js'
const props = defineProps(PROPS_OPTIONS_TITLE_INDEX)
const { titleIndex, examIndex } = toRefs(props)
</script>
<template>
  <span> {{ titleIndex || examIndex }}.</span>
</template>
